import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import QuoteBuilder from '../components/QuoteBuilder';
import { partnerAdminService } from '../services/api';

const AdminQuoteBuilderPage = () => {
  const [params] = useSearchParams();
  const requestId = params.get('request');
  const [prefill, setPrefill] = useState(null);
  const [source, setSource] = useState(null);

  useEffect(() => {
    if (requestId) {
      partnerAdminService.getQuotePrefill(requestId)
        .then((d) => {
          const s = d.shipment || {};
          setPrefill({
            ...d.prefill,
            weight_lb: d.prefill?.weight_lb ?? '',
            length_in: '', width_in: '', height_in: '',
          });
          setSource(d.source_label || 'From partner request');
        })
        .catch(() => { setPrefill(null); setSource(null); });
    }
  }, [requestId]);

  return (
    <DashboardLayout>
      <div data-testid="admin-quote-builder-page">
        <QuoteBuilder intelPrefill={prefill} intelSource={source} />
      </div>
    </DashboardLayout>
  );
};

export default AdminQuoteBuilderPage;
